// import { productPriceHandler } from "@/helpers/product";

// const gtmEvent = (event, data) => {
//   if (typeof window != undefined) {
//     window.dataLayer = window.dataLayer || [];
//     console.log(event, data);

//     setTimeout(() => {
//       window.dataLayer = window.dataLayer || [];
//       window?.dataLayer?.push({ event: event, ...data });
//     }, 1000);
//   }
// };

// const finalProductPrice = (product) => {
//   const priceObj = product?.extension_attributes || product?.prices_with_tax;

//   const discountedPrice = productPriceHandler(
//     priceObj.discounted_price,
//     priceObj.discounted_price_from,
//     priceObj.discounted_price_to
//   );
//   const originalPrice = priceObj.original_price || 0;
//   return discountedPrice || originalPrice;
// };

// // pdp page
// const event_view_item = (product) =>
//   gtmEvent("view_item", {
//     items: [
//       {
//         id: Array.isArray(product?.sku) ? product?.sku?.[0] : product?.sku,
//         brand: product?.option_text_brand?.at(0),
//         category:
//           Array.from(
//             new Set([
//               product?._category_?.main_category?.name,
//               ...product?._category_?.sub_categories?.map((prod) => prod?.name),
//             ])
//           )?.join("/") || null,
//         name: product?.name?.at(0),
//         price: finalProductPrice(product),
//         quantity: product?.stock?.qty,
//         variant: null,
//         list_name: "Product View",
//       },
//     ],
//   });

// // category page
// const event_view_item_list = (productList) =>
//   gtmEvent("view_item_list", {
//     items: productList.map((product, i) => ({
//       id: Array.isArray(product?.sku) ? product?.sku?.[0] : product?.sku,
//       brand: product?.option_text_brand?.at(0),
//       category:
//         Array.from(
//           new Set([
//             product?._category_?.main_category?.name,
//             ...product?._category_?.sub_categories?.map((prod) => prod?.name),
//           ])
//         )?.join("/") || null, // check this
//       list_name: product?._category_?.main_category?.name || null, // check this
//       name: product?.name?.at(0),
//       list_position: i + 1,
//       price: finalProductPrice(product),
//       quantity: product?.stock?.qty,
//       variant: null,
//     })),
//   });

// // cart page
// const event_cart_page = (productList, coupon_code) => {
//   gtmEvent("set_checkout_option", {
//     checkout_option: "begin_checkout",
//     checkout_step: 1,
//   });

//   gtmEvent("begin_checkout", {
//     checkout_step: 1,
//     coupon: coupon_code || "",
//     items: productList.map((product) => ({
//       id: product?.extension_attributes?.product_sku,
//       brand: product?.extension_attributes?.brand_name || "Default",
//       category:
//         product?.extension_attributes?.category_names?.join("/") || null,
//       list_name: "Cart View",
//       name: Array.isArray(product?.name) ? product?.name?.at(0) : product?.name,
//       price: finalProductPrice(product),
//       quantity: product?.qty,
//       variant: null,
//     })),
//   });
// };

// // checkout page
// const event_checkout_page = (productList, coupon_code) => {
//   gtmEvent("set_checkout_option", {
//     checkout_option: "checkout_progress",
//     checkout_step: 2,
//   });

//   gtmEvent("checkout_progress", {
//     checkout_step: 2,
//     coupon: coupon_code || "",
//     items: productList.map((product) => ({
//       id: product?.extension_attributes?.product_sku,
//       brand: product?.extension_attributes?.brand_name || "Default",
//       category:
//         product?.extension_attributes?.category_names?.join("/") || null,
//       list_name: "Cart View",
//       name: Array.isArray(product?.name) ? product?.name?.at(0) : product?.name,
//       price: finalProductPrice(product),
//       quantity: product?.qty,
//       variant: null,
//     })),
//   });
// };

// // success page
// const event_purchase = (order) =>
//   gtmEvent("purchase", {
//     ecommerce: {
//       purchase: {
//         actionField: {
//           actionType: "purchase",
//           coupon: order?.coupon_code || "",
//           created_at: order?.created_at,
//           discount: order?.discount_amount || 0,
//           orderId: order?.entity_id,
//           revenue: order?.grand_total,
//           shipping: order?.base_shipping_amount,
//           subtotal: order?.subtotal_incl_tax || 0,
//           tax: order?.base_tax_amount || 0,
//         },
//         products: order?.items?.map((product) => ({
//           id: product?.item_id || "", // check this
//           name: Array.isArray(product?.name)
//             ? product?.name?.at(0)
//             : product?.name,
//           price: finalProductPrice(product),
//           quantity: product?.qty_ordered,
//           sku: product?.sku || "",
//         })),
//       },
//     },
//   });

// export {
//   event_view_item,
//   event_view_item_list,
//   event_cart_page,
//   event_checkout_page,
//   event_purchase,
// };

// My work !!

function getDiscount(original_price, price) {
  return original_price !== price && price !== 0 ? original_price - price : 0;
}

export const pushToDataLayer = (event, data, session) => {
  if (typeof window != undefined) {
    const user_mobile = session?.user?.custom_attributes?.find(
      (attr) => attr?.attribute_code === "mobile_number"
    )?.value;
    window.dataLayer = window.dataLayer || [];
    window?.dataLayer?.push({ ecommerce: null });
    window?.dataLayer?.push({
      event,
      ecommerce: data,
      ...(session && {
        user: {
          ...(session?.user?.id && { id: session?.user?.id }),
          name: `${session?.user?.firstname} ${session?.user?.lastname}`,
          email: session?.user?.email,
          mobile_number: user_mobile?.startsWith("00966")
            ? `+${user_mobile?.slice(2)}`
            : user_mobile?.startsWith("966")
            ? `+${user_mobile}`
            : `+966${user_mobile?.value}`,
        },
      }),
    });
  }
};

// Success Page

export const event_purchase = (
  order,
  session,
  email,
  firstname,
  lastname,
  telephone
) =>
  pushToDataLayer(
    "purchase",
    {
      transaction_id: order?.increment_id,
      value: order?.grand_total,
      tax: order?.tax_amount,
      shipping: order?.shipping_amount,
      currency: "SAR",
      // coupon: "SUMMER_SALE",
      items: order?.items?.map((item, i) => {
        return {
          item_id: item?.sku,
          item_name: item?.name,
          // coupon: "SUMMER_FUN",
          discount: getDiscount(
            item?.extension_attributes?.original_price,
            item?.extension_attributes?.special_price
          ),
          index: i + 1,
          ...(item?.extension_attributes?.brand_name && {
            item_brand: item?.extension_attributes?.brand_name,
          }),
          ...(item?.extension_attributes?.category_names?.at(0) && {
            item_category:
              item?.extension_attributes?.category_names?.at(0)?.name,
          }),
          ...(item?.extension_attributes?.category_names?.at(1) && {
            item_category1:
              item?.extension_attributes?.category_names?.at(1)?.name,
          }),
          ...(item?.extension_attributes?.category_names?.at(2) && {
            item_category2:
              item?.extension_attributes?.category_names?.at(2)?.name,
          }),
          ...(item?.extension_attributes?.category_names?.at(3) && {
            item_category3:
              item?.extension_attributes?.category_names?.at(3)?.name,
          }),
          ...(item?.extension_attributes?.category_names?.at(4) && {
            item_category4:
              item?.extension_attributes?.category_names?.at(4)?.name,
          }),
          ...(item?.extension_attributes?.category_names?.at(5) && {
            item_category5:
              item?.extension_attributes?.category_names?.at(5)?.name,
          }),
          price:
            item?.extension_attributes?.special_price ||
            item?.extension_attributes?.original_price,
          quantity: item?.qty,
        };
      }),
    },
    session?.user
      ? session
      : {
          user: {
            firstname,
            lastname,
            email,
            custom_attributes: [
              { attribute_code: "mobile_number", value: telephone },
            ],
          },
        }
  );

/* Check out Page  */
export const event_checkout_started = (cartData) =>
  pushToDataLayer("begin_checkout", {
    currency: "SAR",
    value: cartData?.grand_total,
    // coupon: "SUMMER_FUN",
    items: cartData?.items?.map((item, i) => {
      return {
        item_id: item?.extension_attributes?.product_sku,
        item_name: item?.name,
        // coupon: "SUMMER_FUN",
        discount: getDiscount(
          item?.extension_attributes?.original_price,
          item?.extension_attributes?.special_price
        ),
        index: i + 1,
        ...(item?.extension_attributes?.brand_name && {
          item_brand: item?.extension_attributes?.brand_name,
        }),
        ...(item?.extension_attributes?.category_names?.at(0) && {
          item_category: item?.extension_attributes?.category_names?.at(0),
        }),
        ...(item?.extension_attributes?.category_names?.at(1) && {
          item_category1: item?.extension_attributes?.category_names?.at(1),
        }),
        ...(item?.extension_attributes?.category_names?.at(2) && {
          item_category2: item?.extension_attributes?.category_names?.at(2),
        }),
        ...(item?.extension_attributes?.category_names?.at(3) && {
          item_category3: item?.extension_attributes?.category_names?.at(3),
        }),
        ...(item?.extension_attributes?.category_names?.at(4) && {
          item_category4: item?.extension_attributes?.category_names?.at(4),
        }),
        ...(item?.extension_attributes?.category_names?.at(5) && {
          item_category5: item?.extension_attributes?.category_names?.at(5),
        }),
        price:
          item?.extension_attributes?.special_price ||
          item?.extension_attributes?.original_price,
        quantity: item?.qty,
      };
    }),
  });

export const event_shipping_info = (cartData) =>
  pushToDataLayer("add_shipping_info", {
    currency: "SAR",
    value: cartData?.grand_total,
    // coupon: "SUMMER_FUN",
    items: cartData?.items?.map((item, i) => {
      return {
        item_id: item?.extension_attributes?.product_sku,
        item_name: item?.name,
        // coupon: "SUMMER_FUN",
        discount: getDiscount(
          item?.extension_attributes?.original_price,
          item?.extension_attributes?.special_price
        ),
        index: i + 1,
        ...(item?.extension_attributes?.brand_name && {
          item_brand: item?.extension_attributes?.brand_name,
        }),
        ...(item?.extension_attributes?.category_names?.at(0) && {
          item_category: item?.extension_attributes?.category_names?.at(0),
        }),
        ...(item?.extension_attributes?.category_names?.at(1) && {
          item_category1: item?.extension_attributes?.category_names?.at(1),
        }),
        ...(item?.extension_attributes?.category_names?.at(2) && {
          item_category2: item?.extension_attributes?.category_names?.at(2),
        }),
        ...(item?.extension_attributes?.category_names?.at(3) && {
          item_category3: item?.extension_attributes?.category_names?.at(3),
        }),
        ...(item?.extension_attributes?.category_names?.at(4) && {
          item_category4: item?.extension_attributes?.category_names?.at(4),
        }),
        ...(item?.extension_attributes?.category_names?.at(5) && {
          item_category5: item?.extension_attributes?.category_names?.at(5),
        }),
        price:
          item?.extension_attributes?.special_price ||
          item?.extension_attributes?.original_price,
        quantity: item?.qty,
      };
    }),
  });

export const event_payment_info = (cartData, payment_type) =>
  pushToDataLayer("add_payment_info", {
    currency: "SAR",
    value: cartData?.grand_total,
    // coupon: "SUMMER_FUN",
    payment_type,
    items: cartData?.items?.map((item, i) => {
      return {
        item_id: item?.extension_attributes?.product_sku,
        item_name: item?.name,
        // coupon: "SUMMER_FUN",
        discount: getDiscount(
          item?.extension_attributes?.original_price,
          item?.extension_attributes?.special_price
        ),
        index: i + 1,
        ...(item?.extension_attributes?.brand_name && {
          item_brand: item?.extension_attributes?.brand_name,
        }),
        ...(item?.extension_attributes?.category_names?.at(0) && {
          item_category: item?.extension_attributes?.category_names?.at(0),
        }),
        ...(item?.extension_attributes?.category_names?.at(1) && {
          item_category1: item?.extension_attributes?.category_names?.at(1),
        }),
        ...(item?.extension_attributes?.category_names?.at(2) && {
          item_category2: item?.extension_attributes?.category_names?.at(2),
        }),
        ...(item?.extension_attributes?.category_names?.at(3) && {
          item_category3: item?.extension_attributes?.category_names?.at(3),
        }),
        ...(item?.extension_attributes?.category_names?.at(4) && {
          item_category4: item?.extension_attributes?.category_names?.at(4),
        }),
        ...(item?.extension_attributes?.category_names?.at(5) && {
          item_category5: item?.extension_attributes?.category_names?.at(5),
        }),
        price:
          item?.extension_attributes?.special_price ||
          item?.extension_attributes?.original_price,
        quantity: item?.qty,
      };
    }),
  });

// Cart Section
export const event_view_cart = (cartData) =>
  pushToDataLayer("view_cart", {
    currency: "SAR",
    value: cartData?.grand_total,
    items: cartData?.items?.map((item, i) => {
      return {
        item_id: item?.extension_attributes?.product_sku,
        item_name: item?.name,
        // coupon: "SUMMER_FUN",
        discount: getDiscount(
          item?.extension_attributes?.original_price,
          item?.extension_attributes?.special_price
        ),
        index: i + 1,
        ...(item?.extension_attributes?.brand_name && {
          item_brand: item?.extension_attributes?.brand_name,
        }),
        ...(item?.extension_attributes?.category_names?.at(0) && {
          item_category: item?.extension_attributes?.category_names?.at(0),
        }),
        ...(item?.extension_attributes?.category_names?.at(1) && {
          item_category1: item?.extension_attributes?.category_names?.at(1),
        }),
        ...(item?.extension_attributes?.category_names?.at(2) && {
          item_category2: item?.extension_attributes?.category_names?.at(2),
        }),
        ...(item?.extension_attributes?.category_names?.at(3) && {
          item_category3: item?.extension_attributes?.category_names?.at(3),
        }),
        ...(item?.extension_attributes?.category_names?.at(4) && {
          item_category4: item?.extension_attributes?.category_names?.at(4),
        }),
        ...(item?.extension_attributes?.category_names?.at(5) && {
          item_category5: item?.extension_attributes?.category_names?.at(5),
        }),
        price:
          item?.extension_attributes?.special_price ||
          item?.extension_attributes?.original_price,
        quantity: item?.qty,
      };
    }),
  });

export const event_remove_from_cart = (product) =>
  pushToDataLayer("remove_from_cart", {
    currency: "SAR",
    value:
      product?.qty *
      (product?.extension_attributes?.special_price ||
        product?.extension_attributes?.original_price),
    items: [
      {
        item_id: product?.extension_attributes?.product_sku,
        item_name: product?.name,
        // coupon: "SUMMER_FUN",
        discount: getDiscount(
          product?.extension_attributes?.original_price,
          product?.extension_attributes?.special_price
        ),
        index: 1,
        ...(product?.extension_attributes?.brand_name && {
          item_brand: product?.extension_attributes?.brand_name,
        }),
        ...(product?.extension_attributes?.category_names?.at(0) && {
          item_category: product?.extension_attributes?.category_names?.at(0),
        }),
        ...(product?.extension_attributes?.category_names?.at(1) && {
          item_category2: product?.extension_attributes?.category_names?.at(1),
        }),
        ...(product?.extension_attributes?.category_names?.at(2) && {
          item_category3: product?.extension_attributes?.category_names?.at(2),
        }),
        ...(product?.extension_attributes?.category_names?.at(3) && {
          item_category4: product?.extension_attributes?.category_names?.at(3),
        }),
        ...(product?.extension_attributes?.category_names?.at(4) && {
          item_category5: product?.extension_attributes?.category_names?.at(4),
        }),
        price:
          product?.extension_attributes?.special_price ||
          product?.extension_attributes?.original_price,
        quantity: product?.qty,
      },
    ],
  });

export const event_add_to_cart = (product, qty) =>
  pushToDataLayer("add_to_cart", {
    currency: "SAR",
    value:
      (product?.prices_with_tax?.price ||
        product?.prices_with_tax?.original_price) * qty,
    items: [
      {
        item_id: product?.sku,
        item_name: product?.name?.[0],
        // affiliation: "Google Merchandise Store",
        // coupon: "SUMMER_FUN",
        discount: getDiscount(
          product?.prices_with_tax?.original_price,
          product?.prices_with_tax?.price
        ),
        index: 1,
        ...(product?.option_text_brand?.at(0) && {
          item_brand: product?.option_text_brand?.at(0),
        }),
        ...(product?._category_?.main_category?.name && {
          item_category: product?._category_?.main_category?.name,
          item_list_name: product?._category_?.main_category?.name,
        }),
        ...(product?._category_?.sub_categories?.at(0)?.name && {
          item_category2: product?._category_?.sub_categories?.at(0)?.name,
        }),
        ...(product?._category_?.sub_categories?.at(1)?.name && {
          item_category3: product?._category_?.sub_categories?.at(1)?.name,
        }),
        ...(product?._category_?.sub_categories?.at(2)?.name && {
          item_category4: product?._category_?.sub_categories?.at(2)?.name,
        }),
        ...(product?._category_?.sub_categories?.at(3)?.name && {
          item_category5: product?._category_?.sub_categories?.at(3)?.name,
        }),
        ...(product?._category_?.main_category?.category_id && {
          item_list_id: String(product?._category_?.main_category?.category_id),
        }),
        price:
          product?.prices_with_tax?.price ||
          product?.prices_with_tax?.original_price,
        quantity: qty,
      },
    ],
  });

export const event_add_to_wishlist_from_cart = (product) =>
  pushToDataLayer("add_to_wishlist", {
    currency: "SAR",
    value:
      product?.qty *
      (product?.extension_attributes?.special_price ||
        product?.extension_attributes?.original_price),
    items: [
      {
        item_id: product?.extension_attributes?.product_sku,
        item_name: product?.name,
        // coupon: "SUMMER_FUN",
        discount: getDiscount(
          product?.extension_attributes?.original_price,
          product?.extension_attributes?.special_price
        ),
        index: 1,
        ...(product?.extension_attributes?.brand_name && {
          item_brand: product?.extension_attributes?.brand_name,
        }),
        ...(product?.extension_attributes?.category_names?.at(0) && {
          item_category: product?.extension_attributes?.category_names?.at(0),
        }),
        ...(product?.extension_attributes?.category_names?.at(1) && {
          item_category2: product?.extension_attributes?.category_names?.at(1),
        }),
        ...(product?.extension_attributes?.category_names?.at(2) && {
          item_category3: product?.extension_attributes?.category_names?.at(2),
        }),
        ...(product?.extension_attributes?.category_names?.at(3) && {
          item_category4: product?.extension_attributes?.category_names?.at(3),
        }),
        ...(product?.extension_attributes?.category_names?.at(4) && {
          item_category5: product?.extension_attributes?.category_names?.at(4),
        }),
        price:
          product?.extension_attributes?.special_price ||
          product?.extension_attributes?.original_price,
        quantity: product?.qty,
      },
    ],
  });

// related to +,- from cart page
export const event_toggle_from_cart_page = (product, qty, event_name) =>
  pushToDataLayer(event_name, {
    currency: "SAR",
    value:
      qty *
      (product?.extension_attributes?.special_price ||
        product?.extension_attributes?.original_price),
    items: [
      {
        item_id: product?.extension_attributes?.product_sku,
        item_name: product?.name,
        // coupon: "SUMMER_FUN",
        discount: getDiscount(
          product?.extension_attributes?.original_price,
          product?.extension_attributes?.special_price
        ),
        index: 1,
        ...(product?.extension_attributes?.brand_name && {
          item_brand: product?.extension_attributes?.brand_name,
        }),
        ...(product?.extension_attributes?.category_names?.at(0) && {
          item_category: product?.extension_attributes?.category_names?.at(0),
        }),
        ...(product?.extension_attributes?.category_names?.at(1) && {
          item_category2: product?.extension_attributes?.category_names?.at(1),
        }),
        ...(product?.extension_attributes?.category_names?.at(2) && {
          item_category3: product?.extension_attributes?.category_names?.at(2),
        }),
        ...(product?.extension_attributes?.category_names?.at(3) && {
          item_category4: product?.extension_attributes?.category_names?.at(3),
        }),
        ...(product?.extension_attributes?.category_names?.at(4) && {
          item_category5: product?.extension_attributes?.category_names?.at(4),
        }),
        price:
          product?.extension_attributes?.special_price ||
          product?.extension_attributes?.original_price,
        quantity: qty,
      },
    ],
  });

// PDP (event_name is used for select item event when i click on any product card)
export const event_view_item = (product, event_name) =>
  pushToDataLayer(event_name || "view_item", {
    currency: "SAR",
    value:
      product?.prices_with_tax?.price ||
      product?.prices_with_tax?.original_price,
    items: [
      {
        item_id: product?.sku,
        item_name: product?.name?.[0],
        // coupon: "SUMMER_FUN",
        discount: getDiscount(
          product?.prices_with_tax?.original_price,
          product?.prices_with_tax?.price
        ),
        index: 1,
        ...(product?.option_text_brand?.at(0) && {
          item_brand: product?.option_text_brand?.at(0),
        }),
        ...(product?._category_?.main_category?.name && {
          item_category: product?._category_?.main_category?.name,
          item_list_name: product?._category_?.main_category?.name,
        }),
        ...(product?._category_?.sub_categories?.at(0)?.name && {
          item_category2: product?._category_?.sub_categories?.at(0)?.name,
        }),
        ...(product?._category_?.sub_categories?.at(1)?.name && {
          item_category3: product?._category_?.sub_categories?.at(1)?.name,
        }),
        ...(product?._category_?.sub_categories?.at(2)?.name && {
          item_category4: product?._category_?.sub_categories?.at(2)?.name,
        }),
        ...(product?._category_?.sub_categories?.at(3)?.name && {
          item_category5: product?._category_?.sub_categories?.at(3)?.name,
        }),
        ...(product?._category_?.main_category?.category_id && {
          item_list_id: String(product?._category_?.main_category?.category_id),
        }),
        price:
          product?.prices_with_tax?.price ||
          product?.prices_with_tax?.original_price,
        quantity: 1,
      },
    ],
  });

// Category Page
export const event_view_item_list = (currentCategory, products) =>
  pushToDataLayer("view_item_list", {
    item_list_id: String(currentCategory?.id),
    item_list_name: currentCategory?.name,
    items: products?.map((product, i) => {
      return {
        item_id: product?.sku,
        item_name: product?.name?.[0],
        discount: getDiscount(
          product?.prices_with_tax?.original_price,
          product?.prices_with_tax?.price
        ),
        index: i + 1,
        ...(product?.option_text_brand?.at(0) && {
          item_brand: product?.option_text_brand?.at(0),
        }),
        ...(product?._category_?.main_category?.name && {
          item_category: product?._category_?.main_category?.name,
          item_list_name: product?._category_?.main_category?.name,
        }),
        ...(product?._category_?.sub_categories?.at(0)?.name && {
          item_category2: product?._category_?.sub_categories?.at(0)?.name,
        }),
        ...(product?._category_?.sub_categories?.at(1)?.name && {
          item_category3: product?._category_?.sub_categories?.at(1)?.name,
        }),
        ...(product?._category_?.sub_categories?.at(2)?.name && {
          item_category4: product?._category_?.sub_categories?.at(2)?.name,
        }),
        ...(product?._category_?.sub_categories?.at(3)?.name && {
          item_category5: product?._category_?.sub_categories?.at(3)?.name,
        }),
        ...(product?._category_?.main_category?.category_id && {
          item_list_id: String(product?._category_?.main_category?.category_id),
        }),
        price:
          product?.prices_with_tax?.price ||
          product?.prices_with_tax?.original_price,
        quantity: 1,
      };
    }),
  });

export const event_search_result_item_list = (
  inputSearchValue,
  total_items
) => {
  pushToDataLayer("search_term", {
    key_word: inputSearchValue,
    total_items,
  });
};

export const event_user_login = (user) => {
  const { firstname, lastname, email, id, custom_attributes } = user || {};
  const mobile = custom_attributes
    ?.filter((item) => item.attribute_code.includes("mobile") && item.value)
    ?.at(0)?.value;
  const userData = {
    firstname,
    lastname,
    user_id: id,
    ...(email ? { email } : {}),
    ...(mobile ? { mobile } : {}),
  };
  console.log(userData);
  pushToDataLayer("user_login", userData);
};
